import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TaskProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function Task({ color = RoutalPalette.secondary60, style = {} }: TaskProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" style={{ height: `16px`, width: `16px`, ...style }}>
      <g>
        <path
          fill={color}
          strokeWidth="0px"
          d="M6,.18C2.79.18.18,2.79.18,6s2.61,5.82,5.82,5.82,5.82-2.61,5.82-5.82S9.21.18,6,.18ZM6.75,8.48c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-2.8c0-.41.34-.75.75-.75s.75.34.75.75v2.8ZM6,4.27c-.41,0-.75-.34-.75-.75s.33-.75.75-.75h0c.41,0,.75.34.75.75s-.34.75-.75.75Z"
        />
      </g>
    </SvgIcon>
  );
}
